import { Platform } from 'react-native'

export const isIOS = () =>
	Platform.OS === 'web' &&
	(/iP(hone|od|ad)/.test(window.navigator.userAgent) ||
		window.navigator.userAgent.includes('AppleWebKit/605.1.15'))

export const isOldIOS = () => {
	if (!isIOS()) return false
	const userAgent = window.navigator.userAgent
	const isNew =
		userAgent.includes('iPhone') &&
		Number(
			userAgent
				.split('/')
				?.find(p => p.includes('Mobile'))
				?.split(' ')?.[0]
		) > 17
	return !isNew
}
